var Event = /** @class */ (function () {
    function Event(name) {
        this.name = name;
        this.handlers = [];
    }
    /**
     * Add handler to current Event
     */
    Event.prototype.addHandler = function (handler) {
        this.handlers.push(handler);
    };
    /**
     * Remove handler from current Event
     */
    Event.prototype.removeHandler = function (handler) {
        this.handlers = this.handlers.filter(function (h) { return h !== handler; });
    };
    /**
     * Call all handlers in all priorities of current Event
     */
    Event.prototype.call = function () {
        var eventArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            eventArgs[_i] = arguments[_i];
        }
        this.handlers.forEach(function (handler) {
            try {
                handler.apply(void 0, eventArgs);
            }
            catch (err) {
                console.error(err);
            }
        });
    };
    return Event;
}());
var EventAggregator = /** @class */ (function () {
    function EventAggregator() {
        this.events = {};
    }
    /**
     * Get Event by name
     */
    EventAggregator.prototype.getEvent = function (name) {
        var event = this.events[name];
        if (!event) {
            event = new Event(name);
            this.events[name] = event;
        }
        return event;
    };
    EventAggregator.prototype.subscribe = function (name, handler) {
        var _this = this;
        var event = this.getEvent(name);
        event.addHandler(handler);
        return function () {
            _this.unsubscribe(name, handler);
        };
    };
    EventAggregator.prototype.unsubscribe = function (name, handler) {
        var event = this.getEvent(name);
        event.removeHandler(handler);
    };
    EventAggregator.prototype.dispatch = function (name) {
        var eventArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventArgs[_i - 1] = arguments[_i];
        }
        var event = this.getEvent(name);
        if (event) {
            event.call.apply(event, eventArgs);
        }
    };
    /**
     * Subscribe to Event and unsubscribe after call
     */
    EventAggregator.prototype.once = function (name, handler) {
        var event = this.getEvent(name);
        var handlerWrapper = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result = handler.apply(void 0, args);
            if (result) {
                event.removeHandler(handlerWrapper);
            }
        };
        event.addHandler(handlerWrapper);
        return { event: event, handlerWrapper: handlerWrapper };
    };
    return EventAggregator;
}());
var events = new EventAggregator();export{EventAggregator as default,events};